import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useTheme } from '@mui/material/styles';
import { Order } from '../../../../app/services/api/orderManagementClient';

interface SalesOverTimeProps {
  orders: Order[];
}

const SalesOverTime = ({ orders }: SalesOverTimeProps) => {
  const theme = useTheme();

  // Group sales by delivery month
  const monthTotals: { [month: string]: number } = {};
  orders.forEach(order => {
    const date = new Date(order.deliveryDate);
    const key = `${date.getFullYear()}-${date.getMonth() + 1}`;
    monthTotals[key] = (monthTotals[key] || 0) + (order.totalCost || 0);
  });
  const data = Object.entries(monthTotals).map(([month, total]) => ({ month, total }));

  return (
    <ResponsiveContainer width="100%"
      height={200}>
      <LineChart data={data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3"
          stroke={theme.palette.divider} />
        <XAxis dataKey="month"
          stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <YAxis stroke={theme.palette.text.primary}
          style={{ fontSize: theme.typography.textSM.fontSize }} />
        <Tooltip contentStyle={{
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.textSM.fontSize,
        }} />
        <Line type="monotone"
          dataKey="total"
          stroke={theme.palette.secondary.main}
          strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default SalesOverTime;